var viewer_figure_rtlignore_default = {
  "figure": "Z--PZ"
};
export {
  viewer_figure_rtlignore_default as default
};
//# sourceMappingURL=viewer-figure.rtlignore-scss.js.map
